function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOuterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path_5112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_4412",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LogoOuter_White"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(135.35 104.1) rotate(-32.7)",
    style: {
      fontSize: "51.69215393066406px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(164.29 85.03) rotate(-20.87)",
    style: {
      fontSize: "51.692161560058594px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(204.74 69.8) rotate(-7.83)",
    style: {
      fontSize: "51.69217300415039px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "R"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(244.72 64.47) rotate(3.98)",
    style: {
      fontSize: "51.692176818847656px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "E"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(282.15 66.88) rotate(16.55)",
    style: {
      fontSize: "51.692169189453125px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "N"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(323.46 79.49) rotate(29.24)",
    style: {
      fontSize: "51.69216537475586px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "Z"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(355.68 98.33) rotate(37.44)",
    style: {
      fontSize: "51.69218444824219px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.69, 0.73, -0.73, 0.69, 370.08, 108.08)",
    style: {
      fontSize: "51.69218444824219px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "K"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(399.32 139.83) rotate(59.07)",
    style: {
      fontSize: "51.692169189453125px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(417.27 169.42) rotate(70.22)",
    style: {
      fontSize: "51.69217300415039px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.19, 0.98, -0.98, 0.19, 429.32, 204.76)",
    style: {
      fontSize: "51.69216537475586px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "I"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(433.9 224.47) rotate(87.93)",
    style: {
      fontSize: "51.69217300415039px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "S"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(435.32 261.9) rotate(99.6)",
    style: {
      fontSize: "51.692169189453125px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "E"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(429.19 298.86) rotate(111.37)",
    style: {
      fontSize: "51.692169189453125px",
      fill: "#e5e4e4",
      fontFamily: "futura-pt, sans-serif"
    }
  }, "R")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOuterWhite);
export default __webpack_public_path__ + "static/media/LogoOuterWhite.fb3f9822.svg";
export { ForwardRef as ReactComponent };